(() => {
  const styleId = 'fourwinners-mobile-chat-preview';
  const css = '@media (max-width: 749px) { #chat-preview-message { display: none !important; } }';
  const install = () => {
    const root = document.getElementById('zipchat-shadow-host')?.shadowRoot;
    if (!root || root.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    root.appendChild(style);
  };
  const observer = new MutationObserver((records) => {
    if (records.some((record) => Array.from(record.addedNodes).some((node) => node.id === 'zipchat-shadow-host'))) install();
  });
  const start = () => {
    install();
    observer.observe(document.body, { childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('pageshow', start);
  window.addEventListener('pagehide', () => observer.disconnect());
})();
